import { create } from "zustand";
import CreditService from "../services/CreditService";
import { deepCopyFunction } from "../services/utils";
import {
  getDiscountedCostPerJob,
  getDiscountedPrice
} from "../utils/creditUtils";
const useAllCrditSkusStore = create((set, get) => ({
  data: [],
  fetchedState: "LOADING",
  fetchData: async () => {
    try {
      set({
        fetchedState: "LOADING"
      });
      const response = await CreditService.allCrditSkus();
      const tempData = deepCopyFunction(response ?? []);
      const newData = tempData.map(item => {
        const discountedPrice = getDiscountedPrice({
          mrp: item.maximumRetailPrice,
          discountPercentage: item.discountPercentage
        });
        const discountedCostPerJob = getDiscountedCostPerJob({
          noOfJobs: item.noOfJobs,
          discountedTotalPrice: discountedPrice
        });
        item.discountedCostPerJob = discountedCostPerJob;
        item.discountedPrice = discountedPrice;
        if (item.maxQuantityAllowed > 1) {
          item.unitPrice = item.maximumRetailPrice;
          item.unitCredits = item.credits;
        }
        return item;
      });
      set({
        data: newData ?? [],
        fetchedState: "SUCCESS"
      });
    } catch (err) {
      set({
        fetchedState: "ERROR",
        data: []
      });
    }
  },
  updateData: updatedData => {
    const tempData = deepCopyFunction(updatedData ?? []);
    const newData = tempData.map(item => {
      const discountedPrice = getDiscountedPrice({
        mrp: item.maximumRetailPrice,
        discountPercentage: item.discountPercentage
      });
      const discountedCostPerJob = getDiscountedCostPerJob({
        noOfJobs: item.noOfJobs,
        discountedTotalPrice: discountedPrice
      });
      item.discountedCostPerJob = discountedCostPerJob;
      item.discountedPrice = discountedPrice;
      return item;
    });
    set({ data: newData });
  }
}));

export default useAllCrditSkusStore;
